module.exports = __webpack_public_path__ + "static/media/csv-icon.d8647110.svg";